<template>
  <div>
    <!--  -->
    <div v-if="$route.params.id" class="min-h-screen flex-1 mt-1 bg-gray-100  items-center">
      <!--  -->

      <div class="bg-white w-full rounded-lg shadow">

        <!--  -->
        <div class="h-20 py-3 flex items-center border-gray-200 p-6 mt-5">
          <div class="flex w-full">
            <!--  -->
            <button :class="$colors.primary" class="rounded-full flex justify-center items-center w-8 h-8 mr-3"  @click="RouterBack()">
              <i class="material-icons">chevron_left</i>
            </button>
            <!--  -->
            <div class="text-xl font-bold text-blue-600">Ticket details</div>
            <!--  -->
          </div>
        </div>
        <!--  -->

        <!--  -->
        <loading :active.sync="loading" :is-full-page="fullPage"></loading>
        <!--  -->

        <!--  -->
        <div v-if="ticket && !loading">
          <!--  -->
          <div class="flex gap-2">
            <!--  -->
            <div class="w-2/3 flex justify-between shadow border h-auto p-4 m-3 rounded-lg border-gray-100">
              <!--  -->
              <div class="w-full flex flex-col gap-4">
                <!--  -->
                <div class="w-full flex items-center justify-between box-border">
                  <!-- Status -->
                  <div class="flex items-center gap-2 bg-gray-100 py-3 px-4 border rounded-md">
                    <!--  -->
                    <div class="bg-orange-500 text-white flex items-center justify-items-center p-2 rounded-md">
                      <i class="material-icons">check_circle</i>
                    </div>
                    <!--  -->
                    <div class="flex flex-col gap-1">
                      <span class="text-sm">Status</span>
                      <span class="text-xs font-bold rounded-full px-4 text-white" :class="ticket.status.value == 'open'? 'bg-green-500' : 'bg-red-500'">{{ ticket.status.name }}</span>
                    </div>
                    <!--  -->
                  </div>
                  <!-- Status -->
                  <!-- Seller -->
                  <div class="flex items-center gap-2 bg-gray-100 py-3 px-4 border rounded-md">
                    <!--  -->
                    <div class="bg-red-500 text-white flex items-center justify-items-center p-2 rounded-md">
                      <i class="material-icons">person</i>
                    </div>
                    <!--  -->
                    <div class="flex flex-col gap-1">
                      <span class="text-sm">Seller</span>
                      <span class="text-xs font-bold bg-gray-500 rounded-full px-4 text-white">{{ ticket.seller.fullName }}</span>
                    </div>
                    <!--  -->
                  </div>
                  <!-- Seller -->
                  <!-- Department -->
                  <div class="flex items-center gap-2 bg-gray-100 py-3 px-4 border rounded-md">
                    <!--  -->
                    <div class="bg-yellow-500 text-white flex items-center justify-items-center p-2 rounded-md">
                      <i class="material-icons">group</i>
                    </div>
                    <!--  -->
                    <div class="flex flex-col gap-1">
                      <span class="text-sm">Department</span>
                      <span class="text-xs font-bold bg-gray-500 rounded-full px-4 text-white">{{ ticket.department.name }}</span>
                    </div>
                    <!--  -->
                  </div>
                  <!-- Department -->
                  <!-- Priority -->
                  <div class="flex items-center gap-2 bg-gray-100 py-3 px-4 border rounded-md">
                    <!--  -->
                    <div class="bg-purple-500 text-white flex items-center justify-items-center p-2 rounded-md">
                      <i class="material-icons">priority_high</i>
                    </div>
                    <!--  -->
                    <div class="flex flex-col gap-1">
                      <span class="text-sm">Priority</span>
                      <span class="text-xs font-bold text-white rounded-full px-4" :class="ticket.priority.value == 'low' ? 'bg-green-500' : ticket.priority.value == 'medium' ? 'bg-orange-500' : 'bg-red-500'">{{ ticket.priority.name }}</span>
                    </div>
                    <!--  -->
                  </div>
                  <!-- Priority -->
                </div>

                <!--  -->
                <div class="flex items-center gap-4">
                    <!-- Status -->
                    <div class="w-1/2">
                    <!--  -->
                    <div class="border hover:border-blue-500  w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                      <!--  -->
                      <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                        <p>
                          <label for="customerPhone" class="bg-white text-gray-700 px-1">
                            Status <span :class="$colors.required">*</span>
                          </label>
                        </p>
                      </div>
                      <!--  -->

                      <!--  -->
                      <p>
                        <v-select @input="updateElement('status')" v-model="ticket.status" :options="statusOptions" label="name">
                          <template slot="option" slot-scope="option">
                            <span class="" >{{ option.name }}</span>
                          </template>
                        </v-select>
                      </p>
                      <!--  -->
                    </div>
                    <!--  -->
                  </div>
                  <!-- Status -->

                  <!-- Priority -->
                  <div class="w-1/2">
                    <!--  -->
                    <div class="border hover:border-blue-500  w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                      <!--  -->
                      <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                        <p>
                          <label for="customerPhone" class="bg-white text-gray-700 px-1">
                            Priority <span :class="$colors.required">*</span>
                          </label>
                        </p>
                      </div>
                      <!--  -->

                      <!--  -->
                      <p>
                        <v-select @input="updateElement('priority')" v-model="ticket.priority" :options="priorityOptions" label="name">
                          <template slot="option" slot-scope="option">
                            <span class="" >{{ option.name }}</span>
                          </template>
                        </v-select>
                      </p>
                      <!--  -->
                    </div>
                    <!--  -->
                  </div>
                  <!-- Priority -->
                </div>
                <!--  -->

                <!-- Description-->
                <div class="w-full flex items-center justify-between box-border">
                  <div class="w-full flex flex-col gap-2 bg-gray-100 py-3 px-4 border rounded-md">
                    <div class="w-full text-base">
                      <div class="w-full mb-2">
                        <span><b>TicketId:</b> {{ ticket.ticketId }} </span>
                      </div>
                      <div class="w-full mb-2">
                        <b>Description:</b>
                      </div>
                      <p class="w-full mb-2">{{ ticket.description }}</p>
                      <div class="w-full mb-2">
                        <img :src="ticket.picture" alt="image" class="w-full rounded-md">
                      </div>
                    </div>
                    <span class="text-sm"> <strong>Created Date :</strong> {{ $moment(ticket.createdAt).format('yyyy-MM-DD HH:mm') }} </span>
                  </div>
                </div>
                <!-- Description-->
              </div>
              <!--  -->
            </div>
            <!--  -->
            <div class="w-1/3 flex flex-col shadow h-auto p-4 m-3 rounded-lg border-gray-100">
              <!-- refresh -->
              <div class="flex items-center justify-between">
                <div class="text-xl font-bold text-blue-600">Ticket chat</div>
                <button :class="$colors.primary" class="rounded-full flex justify-center items-center w-8 h-8 mr-3"  @click="getTicket(true)">
                  <i class="material-icons">refresh</i>
                </button>
              </div>
              <!--  refresh-->
              <!--  -->
              <div class="flex flex-col gap-4">
                <!-- Chat -->
                <div class="h-80vh mt-4 overflow-y-auto flex flex-col gap-3 border rounded-md p-3" v-if="ticket.chat.length > 0">
                  <div v-for="(item, index) in ticket.chat" :key="index" class="flex flex-col gap-2 bg-gray-100 py-3 px-4 border rounded-md">
                    <div class="flex gap-2">
                      <div :style="{ backgroundColor: getUserColor(item.sender._id) }" class="text-white flex items-center justify-items-center p-2 rounded-md">
                        <span class="text-base">{{ getInitials(item.sender.fullName) }}</span>
                      </div>
                      <div class="flex flex-col gap-1">
                        <span class="text-sm font-bold">{{ item.sender.fullName }}</span>
                        <span class="text-xs text-gray-600">{{ $moment(item.sender.createdAt).format('yyyy-MM-DD HH:mm') }}</span>
                      </div>
                    </div>
                    <div v-if="item.message">
                      <span class="text-sm">{{ item.message }}</span>
                    </div>
                    <div v-if="item.picture">
                      <img class="w-full h-full object-cover rounded-md" :src="item.picture" alt="image">
                    </div>
                  </div>
                </div>
                <!-- Chat -->
                <!-- Message -->
                <div class="mt-4 border hover:border-blue-500 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                  <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                    <p>
                      <label for="description" class="bg-white text-gray-700 px-1">
                        Message
                      </label>
                    </p>
                  </div>
                  <p>
                    <textarea id="message" autocomplete="false" tabindex="0" v-model="message" class="py-2 text-xs px-2 outline-none block h-full w-full"></textarea>
                  </p>
                </div>
                <!-- Message -->
                <!--  Picture -->
                <div class="relative flex w-full my-2 items-center justify-center bg-grey-lighter">
                  <label class="w-full flex flex-col items-center px-2 py-4 bg-white text-blue rounded-lg shadow-lg tracking-wide uppercase border border-blue cursor-pointer hover:bg-blue hover:bg-gray-100">
                      <svg v-if="picture==''" class="w-8 h-8" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                          <path d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" />
                      </svg>
                      <img v-if="picture!=''" :src="picture" alt="" />
                      <span v-if="picture==''" class="mt-2 text-base leading-normal">Select a image</span>
                      <input type='file' @change="handleImage($event)" class="hidden" accept="image/*"   />
                  </label>
                  <!--  -->
                  <div class="absolute -top-5 -right-5 cursor-pointer bg-red-600 text-white flex items-center justify-center rounded-full" v-if="picture.length > 0"  @click="picture=''">
                    <i class="material-icons">close</i>
                  </div>
                </div>
                <!-- Picture -->
                <!-- Send Message -->
                <div class="flex justify-center  items-center has-tooltip">
                  <button class="w-full rounded focus:outline-none outline-none text-gray-100 px-3 py-2 bg-blue-500 hover:shadow-inner hover:bg-blue-700 transition-all duration-300 relative loidingconfirm" :class="loadingSend ? 'noselect' : ''" @click="sendMessage()" :disabled="loadingSend">
                    <loading :active.sync="loadingSend" :is-full-page="fullPage"></loading>
                    Send Message
                  </button>
                </div>
                <!-- Send Message -->
              </div>
              <!--  -->
            </div>
            <!--  --> 
          </div>
          <!--  -->
        </div>
        <!--  -->

        <!--  -->
        <div v-else>
          <div class="flex items-center justify-center py-4"> 
            <span>There Is No Ticket</span>
          </div>
        </div>
        <!--  -->

      </div>
      <!--  -->
    </div>
    <!--  -->
    <div v-else>
      <!--  -->
      <div class="flex items-center justify-center py-4">
        <!--  -->
        <span>Please Choose Ticket</span>
        <!--  -->
      </div>
      <!--  -->
    </div>
    <!--  -->
  </div>
</template>


<script>
export default {
  props: {
    currentUser: { type: Object }
  },
  data() {
    return {
      message: '',
      picture: "",
      ticket: null,
      loading: true,
      fullPage: false,
      priorityOptions: [
        { name: 'Low', value: 'low' },
        { name: 'Medium', value: 'medium' },
        { name: 'High', value: 'high' },
      ],
      statusOptions: [
        { name: 'Open', value: 'open' },
        { name: 'Close', value: 'close' },
      ],
      userColors: {},
      loadingSend: false,
    }
  },
  mounted() {
    this.getTicket()
  },
  methods: {
    RouterBack: function() {
        this.$router.back();
    },
    async getTicket(ticketChat) {
      if (!ticketChat) {
        this.loading = true;
      }

      try {
        const ticketData = await this.$server.get("tickets", {
          id: this.$route.params.id,
        });

        if (ticketData.error) {
          console.error("Error getting ticket:", ticketData.error);
        } else {
          if (ticketChat) {
            this.ticket.chat = ticketData.result.chat;
          } else {
            this.ticket = ticketData.result;
          }
        }
      } catch (error) {
        console.error("Error getting ticket:", error);
      } finally {
        if (!ticketChat) {
          this.loading = false;
        }
      }
    },
    sanitizeInput(content) {
      const doc = new DOMParser().parseFromString(content, 'text/html');
      return doc.body.textContent || "";
    },
    handleImage(e){
        const selectImage=e.target.files[0];
        if(selectImage) this.createBase64Image(selectImage);
    },
    createBase64Image(fileObjet){
      const reader=new FileReader();
      reader.readAsDataURL(fileObjet);
      reader.onload= ()  =>{
        this.picture= reader.result;
      };
    },
    async sendMessage() {
    try {
      if (!this.ticket._id || !this.ticket.seller._id || !(this.message.length > 0 || this.picture.length > 0)) {
        alert("Message Or Image information is missing", "warning");
        return;
      }

        let formData = {
            _id: this.ticket._id,
            chat: {
                picture: this.picture.length > 0 ? this.picture : null,
                message: this.message.length > 0 ? this.sanitizeInput(this.message) : null,
                sender: this.currentUser.type == "Seller" ? this.ticket.seller._id : this.currentUser._id
            }
        };

        this.loadingSend = true;
        const data = await this.$server.sendMessage("tickets", formData);
        this.loadingSend = false;
        
        if (data) {
            alert("Message Created", "success");
            this.getTicket(true);
            this.message = "";
            this.picture = "";
        } else {
            alert(data, "warning");
        }
    } catch (error) {
        console.error("Error saving Message:", error);
        alert("An error occurred while saving the message", "error");
    }
},

    async updateElement(fieldType) {
      try {
        const formData = {
          _id: this.ticket._id,
          [fieldType]: this.ticket[fieldType],
          picture: "",
        };

        const data = await this.$server.update("tickets", formData);

        if (data) {
          alert(`${fieldType} updated`, "success");
        } else {
          alert(data, "warning");
        }
      } catch (error) {
        console.error(`Error updating ${fieldType}:`, error);
        alert(`An error occurred while updating ${fieldType}`, "error");
      }
    },
    getUserColor(userId) {
      if (!this.userColors[userId]) {
        this.userColors[userId] = this.generateRandomColor();
      }
      return this.userColors[userId];
    },
    generateRandomColor() {
      const letters = '0123456789ABCDEF';
      let color = '#';
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    getInitials(fullName) {
      const names = fullName.split(' ');
      const initials = names.map(name => name.charAt(0).toUpperCase());
      return initials.join('');
    },
    checkSize(){
      let base64Length = this.picture.length - (this.picture.indexOf(',') + 1);
      let padding = (this.picture.charAt(this.picture.length - 2) === '=') ? 2 : ((this.picture.charAt(this.picture.length - 1) === '=') ? 1 : 0);
      let fileSize = base64Length * 0.75 - padding
      let sizeImage = this.niceBytes(fileSize);
      let typeSize=sizeImage.split(' ')[1];
      if(typeSize==="bytes" || typeSize==="KB") {
        if(sizeImage.split(' ')[0]<=500)  return true;
        else return false;
      } else return false;
    },
    niceBytes(x){
      const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      let l = 0, n = parseInt(x, 10) || 0;
      while(n >= 1024 && ++l){
          n = n/1024;
      }
      return(n.toFixed(n < 10 && l > 0 ? 1 : 0) + ' ' + units[l]);
    },
  }
}
</script>

<style scoped>
.h-80vh {
  height: 80vh;
}

.-top-5 {
  top: -5px;
} 

.-right-5 {
  right: -5px;
}
</style>